module.exports = __webpack_public_path__ + "static/media/avatar.4662c730.jpg";